module.exports = __webpack_public_path__ + "static/media/evently-app.03fc68bc.png";